import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter
} from '@reduxjs/toolkit'
import * as API from '../utils/api'
import axios from '../utils/axios'

const initialState  = {
    status: 'idle',
    error: null ,
    counts: null
}

export const fetchAlarmsCount = createAsyncThunk(
    'alarms/fetchAlarmsCount',
    async (args, {rejectWithValue}) => {
        return await axios.get(API.ALARM_COUNT_API)
                    .then(response => response.data)
                    .catch((error) => {
                        return rejectWithValue(error.response.data)
                    })
    }
)

const alarmsSlice = createSlice({
    name: 'alarms',
    initialState : initialState ,
    reducers: {
    },
    extraReducers : {
        [fetchAlarmsCount.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchAlarmsCount.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.counts = action.payload
        },
        [fetchAlarmsCount.rejected]: (state, action) => {
            console.log({action})
            state.status = 'failed'
            // state.error = action.payload
        }
    }
})

export default alarmsSlice.reducer